import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { ResponsableService } from '../../../services/ResponsableService';

export interface Props {
    responsable: ReqType.Responsable;
    changeResponsable: (e: ReqType.Responsable) => void;
    editable: boolean;
}

interface State {
}

/**
 * Ce composant permet d'afficher les informations du responsable d'un profil à ce profil
 */
export class ResponsableForm extends React.Component {
    props: Props;
    state: State;
    backupProfil: ReqType.UserView;

    constructor(props: Props) {
        super(props);
        this.state = {
            editable: false,
        };
    }

    render() {
        return (
            <div>
                <h3 style={{fontSize: '25px', marginBottom: '20px'}}>Les informations du responsable: </h3>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Nom :</strong></label>
                    <p>{this.displayNom()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Prénom :</strong></label>
                    <p>{this.displayPrenom()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Lien avec le responsable :</strong></label>
                    <p>{this.displayLien()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Date de naissance :</strong></label>
                    <p>{this.displayDateNaissance()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px', marginBottom: '20px'}}>
                    <label style={{marginRight: '15px'}}><strong>Email :</strong></label>
                    <p>{this.displayEmail()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Telephone :</strong></label>
                    <p>{this.displayPhone()}</p>
                </div>
                <div className="row" style={{marginLeft: '1px'}}>
                    <label style={{marginRight: '15px'}}><strong>Adresse du responsable :</strong></label>
                    <p>{this.displayAdresse()}</p>
                </div>
            </div>
        );
    }

    private displayNom(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.nom}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.nom = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Nom"
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <p>
                        {this.props.responsable.nom}
                    </p>
                </div>
            );
        }
    }

    private displayPrenom(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.prenom}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.prenom = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Prénom"
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <p>
                        {this.props.responsable.prenom}
                    </p>
                </div>
            );
        }
    }

    private displayLien(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.lien}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.lien = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Lien"
                    />
                </div>
            );
        } else {
            return (
                <p>
                    {this.props.responsable.lien}
                </p>
            );
        }
    }

    private displayDateNaissance(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.date_naissance}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.date_naissance = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Date de naissance"
                    />
                </div>
            );
        } else {
            return (
                <p>
                    {this.props.responsable.date_naissance}
                </p>
            );
        }
    }

    private displayPhone(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.telephone}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.telephone = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Telephone"
                    />
                </div>
            );
        } else {
            return (
                <p>
                    {this.props.responsable.telephone}
                </p>
            );
        }
    }

    private displayEmail(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <input
                        className="form-control-lg"
                        value={this.props.responsable.email}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.email = e.target.value;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                        placeholder="Email"
                    />
                </div>
            );
        } else {
            return (
                <p>
                    {this.props.responsable.email}
                </p>
            );
        }
    }

    private displayAdresse(): JSX.Element {
        if (this.props.editable) {
            return (
                <div className="form-group">
                    <AdresseForm
                        adresse={this.props.responsable.adresse}
                        disabled={false}
                        setAdresse={
                            (adresse: ReqType.Adresse) => {
                                var newResponsable =
                                    ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                                newResponsable.adresse = adresse;
                                this.props.changeResponsable(newResponsable);
                            }
                        }
                    />
                </div>
            );
        } else {
            return (
                <AdresseForm
                    adresse={this.props.responsable.adresse}
                    disabled={true}
                    setAdresse={
                        (adresse: ReqType.Adresse) => {
                            var newResponsable =
                                ResponsableService.getInstance().duplicateResponsable(this.props.responsable);
                            newResponsable.adresse = adresse;
                            this.props.changeResponsable(newResponsable);
                        }
                    }
                />
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/ResponsableForm.tsx